/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CustomCodeDefinition } from '../models/custom-code-definition';
import { CustomCodeDefinitionFindByFilePathRequestDto } from '../models/custom-code-definition-find-by-file-path-request-dto';
import { CustomCodeDefinitionPartial } from '../models/custom-code-definition-partial';
import { CustomCodeDefinitionWithRelations } from '../models/custom-code-definition-with-relations';
import { NewCustomCodeDefinition } from '../models/new-custom-code-definition';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class CustomCodeDefinitionControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation customCodeDefinitionControllerCount
   */
  static readonly CustomCodeDefinitionControllerCountPath = '/custom-code-definitions/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation customCodeDefinitionControllerFindByFilePath
   */
  static readonly CustomCodeDefinitionControllerFindByFilePathPath = '/custom-code-definitions/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findByFilePath()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findByFilePath$Response(params?: {
    body?: CustomCodeDefinitionFindByFilePathRequestDto
  }): Observable<StrictHttpResponse<Array<CustomCodeDefinitionWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerFindByFilePathPath, 'get');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CustomCodeDefinitionWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findByFilePath$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findByFilePath(params?: {
    body?: CustomCodeDefinitionFindByFilePathRequestDto
  }): Observable<Array<CustomCodeDefinitionWithRelations>> {

    return this.findByFilePath$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CustomCodeDefinitionWithRelations>>) => r.body as Array<CustomCodeDefinitionWithRelations>)
    );
  }

  /**
   * Path part for operation customCodeDefinitionControllerFindById
   */
  static readonly CustomCodeDefinitionControllerFindByIdPath = '/custom-code-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<CustomCodeDefinitionWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomCodeDefinitionWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<CustomCodeDefinitionWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<CustomCodeDefinitionWithRelations>) => r.body as CustomCodeDefinitionWithRelations)
    );
  }

  /**
   * Path part for operation customCodeDefinitionControllerDeleteById
   */
  static readonly CustomCodeDefinitionControllerDeleteByIdPath = '/custom-code-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation customCodeDefinitionControllerUpdateById
   */
  static readonly CustomCodeDefinitionControllerUpdateByIdPath = '/custom-code-definitions/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: CustomCodeDefinitionPartial
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: CustomCodeDefinitionPartial
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation customCodeDefinitionControllerFind
   */
  static readonly CustomCodeDefinitionControllerFindPath = '/custom-code-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<CustomCodeDefinitionWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CustomCodeDefinitionWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<CustomCodeDefinitionWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CustomCodeDefinitionWithRelations>>) => r.body as Array<CustomCodeDefinitionWithRelations>)
    );
  }

  /**
   * Path part for operation customCodeDefinitionControllerCreate
   */
  static readonly CustomCodeDefinitionControllerCreatePath = '/custom-code-definitions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewCustomCodeDefinition
  }): Observable<StrictHttpResponse<CustomCodeDefinition>> {

    const rb = new RequestBuilder(this.rootUrl, CustomCodeDefinitionControllerService.CustomCodeDefinitionControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomCodeDefinition>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewCustomCodeDefinition
  }): Observable<CustomCodeDefinition> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<CustomCodeDefinition>) => r.body as CustomCodeDefinition)
    );
  }

}
